import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";

function AuthHeader(props) {
  return (
    <div>
      <div className="splash">
        <div className="splash-icon" />
      </div>
      <nav className="navbar navbar-expand navbar-dark absolute-top w-100 py-2">
        <div className="container w-100">
          <Row className="w-100" align="middle">
            <Col span={12}>
              <Link className="navbar-brand fw-bold" to="/">
                <svg>
                  <use xlinkHref="#ion-ios-pulse-strong" />
                </svg>
                &nbsp;FirmTamer
              </Link>
            </Col>
            <Col span={12} className="text-end">
              <span style={{ marginLeft: "auto" }}>
                <Link className="btn btn-success btn-pill my-2 ms-2" to="/auth/sign-up">
                  Sign Up
                </Link>
              </span>
              <span>
                <Link className="btn btn-info btn-pill my-2 ms-2" to="/auth/login">
                  Log In
                </Link>
              </span>
            </Col>
          </Row>
        </div>
      </nav>
      <section className="pb-4 landing-bg text-white overflow-hidden">
        <div className="container py-4">
          <div className="row">
            <div className="col-xl-11 mx-auto">
              <div className="row">
                <div className="col-md-12 col-xl-8 text-center mx-auto"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
// export class AuthHeader extends Component {
//   componentDidMount() {}
//   render() {
//     return (
//       <div>
//         <div className="splash">
//           <div className="splash-icon" />
//         </div>
//         <nav className="navbar navbar-expand navbar-dark absolute-top w-100 py-2">
//           <div className="container">
//             <Link className="navbar-brand fw-bold" to="/">
//               <svg>
//                 <use xlinkHref="#ion-ios-pulse-strong" />
//               </svg>
//               &nbsp;FirmTamer
//             </Link>
//             <div style={{ marginLeft: "auto" }}>
//               <Link className="btn btn-success btn-pill my-2 ms-2" to="/auth/sign-up">
//                 Sign Up
//               </Link>
//             </div>
//             <div>
//               <Link className="btn btn-info btn-pill my-2 ms-2" to="/auth/login">
//                 Log In
//               </Link>
//             </div>
//           </div>
//         </nav>
//         <section className="pb-4 landing-bg text-white overflow-hidden">
//           <div className="container py-4">
//             <div className="row">
//               <div className="col-xl-11 mx-auto">
//                 <div className="row">
//                   <div className="col-md-12 col-xl-8 text-center mx-auto"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     );
//   }
// }

export default AuthHeader;
